/**
 * Mijn Rooster Page (Spoor 2, Verlof MVP — Story 1.4, UX V3)
 *
 * Eigen werkrooster, strikt read-only (FR-4). Reuses `EmployeeScheduleTab`
 * with `canEdit={false}` — its existing bare read-only mode (week toggle +
 * `WeekScheduleGrid`, no bewerk-control, no save-knop) — rather than a new
 * grid implementation.
 */

import { Layout } from '../../components/Layout';
import { useAuth } from '../auth';
import { EmployeeScheduleTab } from './components/EmployeeScheduleTab';

export function MijnRoosterPage() {
  const { user } = useAuth();
  const employeeId = user?.employeeId ?? undefined;

  return (
    <Layout>
      <div data-testid="mijn-rooster-page" className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[#1E293B]">Mijn rooster</h1>
          <p className="mt-1 text-sm text-gray-500">
            Je eigen werkrooster — bekijken, niet bewerken.
          </p>
        </div>

        {employeeId === undefined ? (
          <div className="bg-white p-6 rounded-lg border border-[#E2E8F0] text-sm text-gray-500">
            Geen medewerkerprofiel gekoppeld aan dit account. Neem contact op met HR.
          </div>
        ) : (
          <div className="bg-white p-6 rounded-lg border border-[#E2E8F0]">
            <EmployeeScheduleTab employeeId={employeeId} canEdit={false} />
          </div>
        )}
      </div>
    </Layout>
  );
}
